function setFirstPage(page: number, setPage: Function) {
  if (page > 1) {
    setPage(1);
  }
}

export default setFirstPage;
